<div
  class="mg-forgot-password"
  *ngIf="translate?.username"
  [ngClass]="{ landscape_signup: tamWidth < 767 }"
>
  <div class="mg-forgot-password__content">
    <div class="mg-forgot-password__content__form">
      <div class="mg-forgot-password__content__form__header">
        <div class="mg-forgot-password__content__form__header__title">
          <mat-icon (click)="back()">arrow_forward</mat-icon>
          <span>
            {{ translate?.title }}
          </span>
        </div>
        <div class="mg-forgot-password__content__form__header__img">
          <img
            src="https://cdn.mango-soft.com/mango-core/mango-vertical.svg"
            alt=""
          />
        </div>
      </div>
      <div class="mg-forgot-password__content__form__content">
        <ng-container *ngIf="progress === 'validUser'">
          <span class="mg-forgot-password__content__form__content__title">
            {{ translate?.messageReset }}
          </span>
          <div
            class="mg-forgot-password__content__form__content__form form-group"
          >
            <label for="username">
              {{ translate.username }} <span class="asteriks"> * </span>
            </label>
            <input
              type="text"
              class="input-mg-app"
              id="username"
              name="username"
              [(ngModel)]="username"
              [placeholder]="translate.usernamePlaceholder"
            />
          </div>

          <div class="mg-forgot-password__content__form__content__button">
            <button
              [disabled]="username.length < 4 || initValidUser"
              (click)="validUsername()"
            >
              <span *ngIf="!initValidUser"> {{ translate.buttonSend }} </span>
              <div class="loader-input" *ngIf="initValidUser"></div>
            </button>
          </div>
        </ng-container>
        <ng-container *ngIf="progress === 'validCode'">
          <span class="mg-forgot-password__content__form__content__title">
            {{ translate.messageCheck }}
          </span>
          <div class="mg-forgot-password__content__form__content__code">
            <code-input
              [isCodeHidden]="false"
              [codeLength]="4"
              [initialFocusField]="0"
              (codeChanged)="code = $event"
              (codeCompleted)="code = $event"
            >
            </code-input>
            <div
              style="
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: center;
                padding-top: 4px;
              "
            >
              <span class="asteriks" *ngIf="isInvalidCode">
                {{ translate.invalidCode }}
              </span>
            </div>
            <div class="expires">
              <span style="padding-right: 6px">{{ translate.expire }} </span>
              <span *ngIf="minutes.toString().length === 1">0</span>
              <span> {{ minutes }}</span>
              <span>:</span>
              <span *ngIf="seconds.toString().length === 1">0</span>
              <span>{{ seconds }}</span>
            </div>
          </div>

          <div class="mg-forgot-password__content__form__content__button">
            <button class="mg-button-light" [disabled]="!typeResend"  (click)="validUsername()">
              <span> {{ translate.buttonresend }} </span>
            </button>
            <button
              [disabled]="code.length !== 4 || initValidCode"
              (click)="authSms()"
            >
              <span *ngIf="!initValidCode"> {{ translate.buttonCheck }} </span>
              <div class="loader-input" *ngIf="initValidCode"></div>
            </button>
          </div>
        </ng-container>

        <ng-container *ngIf="progress === 'reset'">
          <span class="mg-forgot-password__content__form__content__title">
            {{ translate.messageComplet }}
          </span>

          <div
            class="primary-modal__content-modal__content-action__email__form form-group"
            style="margin-top: 1rem"
          >
            <label for="email"> {{ translate?.newPassword }} </label>
            <mg-input-password
              [placeholder]="'********'"
              (valueInput)="dataPassword($event)"
            >
            </mg-input-password>
          </div>
          <div class="form-group">
            <label for="confirmPassword">{{
              translate?.confirmPassword
            }}</label>
            <mg-input-password
              [placeholder]="'********'"
              (valueInput)="dataConfirmPassword($event)"
            >
            </mg-input-password>
            <span class="error" *ngIf="isInvalidPassword">
              {{ translate?.passwordNotMatch }}
            </span>
          </div>

          <div class="mg-forgot-password__content__form__content__button">
            <button
              [disabled]="
                isInvalidPassword ||
                this.password.length < 4 ||
                this.confirmPassword.length < 4
              "
              (click)="complet()"
            >
              <span *ngIf="!initValidUser">
                {{ translate.buttonComplet }}
              </span>
              <div class="loader-input" *ngIf="initValidUser"></div>
            </button>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
  <div class="landscape_logo"></div>
</div>
